import React, { useEffect, useState } from 'react';

import './styles.css';
import Popup from '../../../../../components/Popup';
import {FaFilter} from 'react-icons/fa';
import Input from '../../../../../components/Input';

export default function FilterCollaboratorsPopUp(props) {
    const [name, setName] = useState("");
    const [company, setCompany] = useState("");
    const [activity, setActivity] = useState("Todos");


    function onFilter() {
        let auxArray = [...props.collaborators];
        if(name !== "")
            auxArray = auxArray.filter(obj => obj.nome.toLowerCase().includes(name.toLowerCase()));
        if(activity !== ""){
            if(activity === "Ativos") {
                auxArray = auxArray.filter(obj => !obj.inativo);
            }
            else if(activity === "Inativos") {
                auxArray = auxArray.filter(obj => obj.inativo);
            }
        }
        if(company !== "") {
            auxArray = auxArray
                    .filter(item => item.empresas.find(empresa_colaborador => empresa_colaborador.nome === company) !== undefined )
        }
        props.setCollaboratorsToShow(auxArray);
    }

    function onResetFilters() {
        setName("");
        setCompany("");
        setActivity("Todos");
    }

    function isReseted() {
        if(name === "" && company === "" && activity === "Todos")
            return true;
        else
            return false;
    }


    return (
        <Popup
        visibility={props.visibility}
        setVisibility={props.setVisibility}
        tittle="Filtrar"
        icon={<FaFilter/>}
        >
            <div className='collaborators-filter-container'>
                <Input
                label="Nome"
                type="text"
                id="collaborators-filter-name"
                onChange={(e) => setName(e.target.value)}
                cleanValue=""
                value={name}
                />
                <Input
                    label='Empresa'
                    type='select'
                    options={props.companies ? props.companies.map(item => item.nome) : []}
                    id='collaborators-filter-company'
                    onChange={(event) => setCompany(event.target.value)}
                    value={company}
                />
                <Input
                    label='Atividade'
                    type='select'
                    options={['Todos', 'Ativos', 'Inativos']}
                    id='collaborators-filter-activity'
                    onChange={(event) => setActivity(event.target.value)}
                    value={activity}
                />
            </div>
            <button className="blue" onClick={() => {onFilter(); props.setVisibility(false)}}>
                Filtrar
            </button>

            {
                !isReseted() ?
                <button className="red" onClick={() => {onResetFilters()}}>
                    Resetar Filtros
                </button>
                :
                null
            }

        </Popup>

    )

}